import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {lastValueFrom} from "rxjs";
import {InternalSettingDto, PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-internal-setting",
    templateUrl: `./internal-setting.component.html`,
    styleUrl: "./internal-setting.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InternalSettingComponent implements OnInit {
    constructor(private readonly api: PerFormaAPIService) {}

    loading = true;
    list?: InternalSettingDto[];

    async ngOnInit() {
        try {
            this.list = await lastValueFrom(this.api.postApiConfigureInternalList());
        } finally {
            this.loading = false;
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openCreateModal = () => {};
}
